<template>
  <v-app style="margin-top:0px;">
      <v-card flat style="border-radius:0px;height:150px;margin-top: 50px;" class="tst res" >
          <v-container>
              <h2 style="margin-top:70px;">Career Counselling</h2>
          </v-container>
      </v-card>
      <v-card flat style="border-radius:0px;height:100px;margin-top:50px" class="tst man">
          <v-container>
              <h2 style="margin-top:10px;">Career Counselling</h2>
          </v-container>
      </v-card>

      <div class="row">
        <div class="col-lg-9 col-md-9 col-sm-12">
      <v-card flat>
      <v-tabs
      v-model="tab"
      color="red"
      grow
      dark
    >
    <v-tab><h5>Aptitude Test</h5></v-tab>
    <v-tab><h5>Popular Courses</h5></v-tab>
    <v-tab><h5>New Age Courses</h5></v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item style="background-color:white">
        <v-container>
          <div class="row" style="padding-top:20px;">
          <div class="col-lg-6 col-md-6 col-sm-12">
            <img src="https://ischoolconnect.com/blog/wp-content/uploads/2021/09/Why-take-a-career-aptitude-test.jpg" style="height:300px;" />
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <p class="txt" style="padding-top:50px;text-align:justify;">
              Career Counseling is a process that will help you to know and understand yourself 
              and the world of work in order to make career, educational and life decisions. 
              Selecting the right career is very important as career spans one's adult life 
              and defines an individual, the kind of lifestyle one has, the people one interacts with. 
              In short one's career has an impact on the quality of one's life. Applying for higher 
              education abroad is a critical decision, both financially and emotionally. Therefore, 
              it is mandatory to invest adequate time and effort in order to make the right career decision.
            </p>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top:40px;">
            <h2 style="font-weight:500;color:grey;">If You Are Confused About Your Career</h2>
            <p class="txt" style="padding-top:30px;text-align:justify;">
              We at Worldwin, guide you through the maze of questions to find solutions best suited to your profile and parameters ensuring you choose the best Career Path.
              Worldwin has professional and experienced counselors that provide help to identify the professional goals, enable the student to make a wiser academic decision, 
              and give personal guidance to help choose courses that perfectly fit your career or personal goals.
            </p>
            <p class="txt" style="text-align:justify;">
              We also host direct interviews from university representatives & give comprehensive & unbiased 
              information on various study options. Over 90% of our students are references from our past-students.
            </p>
            <p class="txt" style="text-align:justify;">
              The goal of Worldwin through career counseling is to not only help you make the decisions 
              you need to make now, but also to give you the 
              knowledge and skills you need in order to make future career and life decisions.
            </p>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top:40px;">
            <h2 style="font-weight:500;color:grey;">Most Importantly We Do Not Make Any False Promises, <span style="font-style:italic">'What We Promise, We Deliver'</span></h2>
            <p class="txt" style="padding-top:20px;text-align:justify;">
              To assist students to select a career scientifically, Worldwin has created the Academic Pathway Planning Program.
            </p>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top:40px;">
            <h2 style="font-weight:500;color:grey;">Academic Pathway Planning</h2>
            <p class="txt" style="padding-top:20px;text-align:justify;">
              The world is filled with various career choices ranging from medicine 
              to mass communication, engineering to event management, marine biology 
              to information technology. To select the right career from the various 
              options available today, has become a daunting and challenging process. 
              A large number of students continue to choose a career based merely on the 
              fact that their friends are doing the same thing 
              or because their parents told them to do so. This, however, may not be the best way to go about it.
            </p>
            <p class="txt" style="padding-top:20px;text-align:justify;">
              We at Worldwin understand the dilemma of the students while choosing 
              the pathways for higher education. 
              To cater to such needs Worldwin conducts a vocational guidance program 
              called Academic Pathway Planning.
            </p>

            <p style="font-size:16px;color:grey;">Academic Pathway Planning Involves Assessment In 3 Areas:</p>
            <p style="text-align:justify;" class="txt">
              ◉ Aptitude: We assess different abilities which helps identify fields one will excel in
            </p>
            <p style="text-align:justify;" class="txt">
              ◉ Interest: Helps us identify the kind of activities and work one would like to do
            </p>
            <p style="text-align:justify;" class="txt">
              ◉ Personality: It involves multidimensional personality assessment that helps understand who one truly is, one's character traits, qualities and shortcomings.
            </p>
          </div>

          <div class="col-lg-6 col-md-6 col-sm-12" style="padding-top:75px;">
            <h2 style="font-weight:500;color:grey;">Understanding These Internal Factors Is Very Important And Helps At The Following Stages:</h2>
            <p class="txt" style="padding-top:50px;text-align:justify;">◉ Subject selection</p>
            <p class="txt" style="text-align:justify;">◉ Curriculum selection</p>
            <p class="txt" style="text-align:justify;">◉ Stream selection</p>
            <p class="txt" style="text-align:justify;">◉ Bachelors degree selection</p>
            <p class="txt" style="text-align:justify;">◉ Masters degree selection</p>
            <p class="txt" style="text-align:justify;">◉ Career change/shift</p>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12" style="padding-top:75px;">
            <img src="https://t4.ftcdn.net/jpg/05/26/64/61/360_F_526646116_rIpwjXy6cXVr1dHvbxl8tJOutWm1307p.jpg" style="height:300px;" />
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top:50px;">
            <h2 style="font-weight:500;color:grey;">Methodology</h2>
            <p class="txt" style="padding-top:20px;text-align:justify;">◉ Identify the needs of students so that the appropriate test may be administered from the battery of test available with us.</p>
            <p class="txt" style="text-align:justify;">◉ 3-4 hours online / paper-pencil psychometric test.</p>
            <p class="txt" style="text-align:justify;">◉ Report given by a qualified psychologist.</p>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top:50px;">
            <h2 style="font-weight:500;color:grey;">Report</h2>
            <p class="txt" style="padding-top:20px;text-align:justify;">A comprehensive 15+ page report provides:</p>
            <p class="txt" style="padding-top:20px;text-align:justify;">◉ An explanation of the report and how to use it.</p>
            <p class="txt" style="text-align:justify;">◉ Graphic scores of the aptitude, interest and personality tests.</p>
            <p class="txt" style="text-align:justify;">◉ An overview narrative report and summary of the results.</p>
            <p class="txt" style="text-align:justify;">◉ A telephonic consultation with a certified psychologist with a prior appointment.</p>
            <p class="txt" style="text-align:justify;">◉ The results are not a benchmark but an indicator which gives you a platform to work on.</p>
            <p class="txt" style="text-align:justify;">◉ Study / Work options in India and overseas.</p>
          </div>
        </div>
        </v-container>
      </v-tab-item>

      <v-tab-item style="background-color:white">
        <v-container>
          <div class="row" style="padding-top:20px;">
          <div class="col-lg-6 col-md-6 col-sm-12" style="margin-top:25px;">
            <img src="https://www.classcentral.com/report/wp-content/uploads/2020/04/most-popular-all-time-1.png" style="height:200px;" />
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <p class="txt" style="padding-top:20px;text-align:justify;">
              The world is an open door. There is a variety of international opportunities 
              for college students. Potential employers see international experience as a 
              qualification in hiring college graduates. Job opportunity, diverse campus experience, 
              peer learning and overall development are the other prime driving forces.The most popular 
              and sought after courses among Indian students are that of business. Jobs in renewable 
              energy have been trending as well. MBA has been a hot field for quite some time; and there 
              are valid reasons for that. Most students look for a major that will help them develop their 
              managerial skills and focus. Graduates with Computer Science Engineering degree and excellent skills 
              on software development, cloud computing, programming and coding are valued everywhere.
            </p>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12" >
            <h2 style="font-weight:500;">Acoustical Engineering:</h2>
            <p class="txt" style="text-align:justify;">
              A branch of engineering that deals with sound and vibration is called acoustic engineering, commonly known as acoustic engineering. It also covers the use of acoustics, the study of sound and vibration, in technological applications. The design, analysis, and control of sound are often the areas of interest for acoustic engineers. Noise control, sometimes referred to as noise reduction, is one objective of acoustical engineering. Unwanted noise may harm human and animal health and wellbeing significantly, lower student achievement in the classroom, and lead to hearing loss. Many different methods are used to incorporate noise management concepts into technology and design, such as altering sound sources, creating noise barriers, sound absorbers, suppressors, and buffer zones, and using hearing protection (earmuffs or headphones). In this auditorium, transparent baffles were placed to enhance sound projection and reproduction, two crucial acoustical engineering components.
            </p>
            <p class="txt" style="text-align:justify;">Acoustical engineering also deals with the constructive applications of sound, such as the use of ultrasound in medicine, the programming of digital synthesizers, the design of concert halls to improve orchestral sound, and the specification of railway station sound systems to ensure announcements are understandable.</p>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12" >
            <h2 style="font-weight:500;">Aeronautical engineering/Aerospace Engineering:</h2>
            <p class="txt" style="text-align:justify;">
              Originally known as "Aeronautical engineering," the word was changed to "Aerospace engineering" as a result of technological advancements that included spacecraft launch. Engineering courses cover it. It is the most difficult and demanding area in engineering. The primary emphasis of aerospace engineering is the design, development, building, testing, and maintenance of commercial, military, and spacecraft. An "Aerospace Engineer" is someone who has a bachelor's degree in aerospace engineering and specializes in that field.            </p>
            <p class="txt" style="text-align:justify;">Aerospace engineers have a plethora of employment options.</p>
            <p class="txt" style="text-align:justify;">Both the public and commercial sectors are open to employment for aerospace engineers.</p>
            <p class="txt" style="text-align:justify;">Aerospace engineers might find employment both domestically and overseas.</p>
            <p class="txt" style="text-align:justify;">In essence, an aerospace engineer builds, tests, investigates, and maintains the functionality of military and civilian aircraft, rockets, missiles, weapons systems, satellites, etc.The Air Force, Airlines, Corporate Research Companies, Helicopter Companies, Defense Ministry, Aviation Companies, NASA, Flying clubs, Aeronautical Laboratories, Aircraft Manufacturers, Government Owned Air Services, and many others are major employers of aerospace engineers. Candidates with a master's degree in aerospace engineering are also eligible for teaching positions.</p>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12" >
            <h2 style="font-weight:500;">Aeronautical engineering/Aerospace Engineering:</h2>
            <p class="txt" style="text-align:justify;"></p>
            <p class="txt" style="text-align:justify;"></p>
            <p class="txt" style="text-align:justify;"></p>
            <p class="txt" style="text-align:justify;"></p>
          </div>
<!-- 
          <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top:40px;">
            <h2 style="font-weight:500;color:grey;">Accounting</h2>
            <p class="txt" style="padding-top:20px;text-align:justify;">
              Accounting is the systematic recording of financial transactions related to a business. 
              It refers to the process of summarizing, 
              analyzing and reporting these transactions to oversight agencies and tax collection entities.
            </p>
          </div> -->

          <!-- <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top:30px;">
            <h2 style="font-weight:500;color:grey;">Architecture And Built Environment</h2>
            <p class="txt" style="padding-top:20px;text-align:justify;">
              The profession of Building Design, open areas, communities, and other 
              artificial constructions and environments. Architecture often includes design or selection 
              of furnishings and decorations, supervision of construction work, and the examination, 
              restoration, or remodeling of existing buildings. Built environment refers to the manmade 
              surroundings that provide the setting for human activity, ranging in scale from buildings 
              and parks or green space to neighborhoods and cities that can often include their 
              supporting infrastructure, such as water supply or energy networks.
            </p>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top:30px;">
            <h2 style="font-weight:500;color:grey;">Design</h2>
            <p class="txt" style="padding-top:20px;text-align:justify;">
              Design is a work process which has a user prospect and stimulate development 
              based on your specific customers’ needs. A plan or drawing used to 
              show the look, function or workings of a building, garment, or other object before it is made.
            </p>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top:30px;">
            <h2 style="font-weight:500;color:grey;">Digital Media And Marketing</h2>
            <p class="txt" style="padding-top:20px;text-align:justify;">
              Digital marketing is marketing of products or services using digital technologies on the Internet, 
              but also including mobile phones, display advertising, and any other digital medium. The activities 
              include search engine optimization(SEO), search engine marketing (SEM), content marketing, content 
              automation, 
              campaign marketing, and e-commerce marketing, social media marketing, social media optimization, etc.
            </p>
          </div> -->
        </div>
        </v-container>
      </v-tab-item>

      <v-tab-item style="background-color:white">
        <v-container>
          <div class="row" style="padding-top:20px;">
          <div class="col-lg-6 col-md-6 col-sm-12" style="margin-top:25px;">
            <img src="https://digiperform.com/wp-content/uploads/2020/10/new-Age-Grow-Audience.png" style="height:250px;" />
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <p class="txt" style="padding-top:20px;text-align:justify;">
              New age courses draw upon new courses and the industry which gives you both the 
              theoretical and pratical experience in your chosen profession that you need for 
              excellent job prospects. This flexibility allows you to take more control over what 
              and how much you know. These courses are in wide variety. There are many institutes 
              that offer new courses. All courses are fully designed in such a way that the students 
              pursuing their course will come to deal with new realities and experiences and it is important 
              for students to 
              analyse their interest and the options available to them. Following are the list of new age course :
            </p>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12" >
            <h2 style="font-weight:500;margin-bottom: 20px;">Design and architecture</h2>
            <p class="txt" style="text-align:justify;"> <strong>1. A good design will enhance your appearance:</strong> </p>
            <p class="txt" style="text-align:justify;">Really, it's fairly straightforward: a decent design will help you seem nice and distinguish yourself from the competitors. It enables you to provide a good first impression on prospective clients. Humans have been proven to develop an initial impression in just a few seconds, but after that view has been formed, it can take much longer to change it. Your customers will have a favorable perception of your business, product, or brand if your graphic designs are expertly created and appealing to the eye.</p>
            <p class="txt" style="text-align:justify;"><strong>2. It gives you a unique edge:</strong></p>
            <p class="txt" style="text-align:justify;">There is a lot of rivalry in the business world nowadays, so you need to figure out how to stand out from the crowd. You may distinguish yourself in a good way with a stunning graphic design. Spend some time and money on an excellent graphic design if you want to stand out to your clients and affect their purchasing decisions. People naturally want to be associated with things that are appealing to the eye and give them a positive feeling. Your business will have a better chance of distinguishing out in your clients' eyes if you invest in quality graphic design.</p>
            <p class="txt" style="text-align:justify;"><strong>3. IT IMPLIES THAT YOU OWN A PROFESSIONAL BUSINESS.</strong> </p>
            <p class="txt" style="text-align:justify;">As mentioned before, graphic design may significantly influence how people make decisions. Customers will have a higher level of confidence in a firm that has invested time and money in a stunning visual design. Any firm may prosper with the aid of perception and presentation. Your appearance is one illustration of this. Putting money into quality graphic design can enable you to showcase yourself in the best light.</p>
            <p class="txt" style="text-align:justify;"><strong>4. Using graphic design, your ideas are distilled in a way that resonates.</strong></p>
            <p class="txt" style="text-align:justify;">Consider how you want to be seen by your clients. Your ideas will be succinctly presented in an engaging visual style that will draw customers. Many clients won't spend the time reading a text that is attempting to convince them to use your service or buy your goods, but if a picture is visually appealing, they will frequently be eager to do so. Every graphic design picture you use for your business must be uniform. This will increase credibility and make it simpler for others to recognize your brand. Excellent graphic design gives you and your clients the consistency you need.</p>
            <p class="txt" style="text-align:justify;"></p>
            <p class="txt" style="text-align:justify;"></p>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12" >
            <h2 style="font-weight:500;margin-bottom: 20px;">Design and architecture</h2>
            <p class="txt" style="text-align:justify;"><strong>Digital Media and marketing:</strong></p>
            <p class="txt" style="text-align:justify;">Any form of marketing that can be measured by marketing experts across the consumer journey and that leverages electronic devices to deliver promotional content. Digital marketing is most commonly used to describe advertising efforts that run on a computer, phone, tablet, or other electronic device. Online video, display advertisements, search engine marketing, paid social ads, and social media postings are just a few examples of the various formats it may take. Digital marketing is frequently contrasted with "traditional marketing" methods like direct mail, billboards, and magazine advertisements. Oddly, conventional marketing is sometimes grouped with television.</p>
            <p class="txt" style="text-align:justify;">Digital marketing should be one of the key objectives of practically every business’s entire marketing plan. Never before has there been a method to keep in such regular contact with your clients, and nothing else gives the kind of personalization that digital data can deliver. You'll be able to achieve your company's growth potential to a greater extent as you embrace the possibility of digital marketing.</p>
          </div>

          <!-- <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top:40px;">
            <h2 style="font-weight:300;color:grey;padding-bottom:20px;">The courses that are trending all over the globe are stated below:</h2>
            <h2 style="font-weight:500;color:grey;">Acoustical Engineering</h2>
            <p class="txt" style="padding-top:20px;text-align:justify;">
              Acoustical engineering involves testing and analysing sound and vibrations in diverse conditions.
            </p>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top:30px;">
            <h2 style="font-weight:500;color:grey;">Astronautical Engineering</h2>
            <p class="txt" style="padding-top:20px;text-align:justify;">
              This specialisation focuses on the role of fundamental sciences and engineering in aircraft and astronautics functions.
            </p>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top:30px;">
            <h2 style="font-weight:500;color:grey;">Construction Project Management:</h2>
            <p class="txt" style="padding-top:20px;text-align:justify;">
              Construction project management (CPM) is the overall planning, coordination, 
              and control of a project from beginning to completion. CPM is aimed at 
              meeting a client's requirement in order to produce a functionally and financially viable project.
            </p>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12" style="padding-top:30px;">
            <h2 style="font-weight:500;color:grey;">Corporate Communication:</h2>
            <p class="txt" style="padding-top:20px;text-align:justify;">
              Corporate Communication is a set of activities involved in managing and 
              orchestrating all internal and external communications 
              aimed at creating favourable point of view among stakeholders on which the company depends.
            </p>
          </div> -->
        </div>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
    </v-card>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <v-card flat style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;margin-top:20px;padding:30px;">
                  <div style="background-color:black;color:white;text-align:center;padding:15px;">
                      <h2>Apply Now</h2>
                  </div>
                  <v-container v-if="otp==false">
                      <v-form ref="form" v-model="valid" lazy-validation>
                          <v-layout row wrap >
                              <v-flex xs12 style="padding-top:10px;" >
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;" a-model="form.name" label="Full Name *" :rules="emptyRule" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.email" label="Email *" :rules="[rules.email]" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.mobileNumber" label="Mobile No *" :rules="[rules.mobileno]" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-autocomplete
                                   outline 
                                   style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                   v-model="selectedCountry"
                                   :items="countries"
                                   color="primary"
                                   label="Preferred Country *"
                                   item-text="countryName"
                                   item-value="countryName"

                                  ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-autocomplete
                                   outline 
                                   style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                   v-model="selectedCourse"
                                   :items="courses"
                                   color="primary"
                                   label="Preferred Course *"
                                   item-text="courses"
                                   item-value="courses"
                                  ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;text-align:center;">
                                  <v-btn :loading="btnSave" large block dark color="primary" @click="getOtp()">Send Message</v-btn>
                              </v-flex>
                          </v-layout>
                      </v-form>
                  </v-container>

                  <v-container v-if="otp==true">
                      <v-form ref="form1" v-model="valid" lazy-validation>
                          <v-layout row wrap>
                              <v-flex xs12>
                                  <label>Enter Your OTP here *</label>
                                  <v-text-field outline style="background-color:white;height:56px" v-model="form1.pin" label="Enter Your OTP here *" :rules="emptyRule" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;text-align:center;">
                                  <v-btn :loading="btnSave1" large block dark color="primary" @click="onSubmit()">Vefity Now</v-btn>
                              </v-flex>
                          </v-layout>
                      </v-form>
                  </v-container>

              </v-card>
          </div>
      </div>

      <v-dialog v-model="dialog" width="500px" persistent>
         <v-card>
           <div style="height:150px;background-color:green;text-align:center;">
             <div style="padding-top:25px;">
                <v-icon style="border:1px solid;border-radius:50px;border-color:white;" color="white" :size="80">check</v-icon>
             </div>
           </div>
           <v-container>
             <div style="text-align:center">
                 <h4>Thank You</h4>
                 <h5 class="txt" style="padding-bottom:15px;">Our Counsellors will get back to you !!</h5>
                 <v-btn depressed large color="error" @click="cancel()">Yes Understand</v-btn>
             </div>
           </v-container>
         </v-card>
     </v-dialog>
  </v-app>
</template>

<script>
import config from "./../../config.json";

export default {
  components: {
  },
  data() {
    return {
      tab: null,
      valid: true,
      btnSave: false,
      btnSave1: false,
      dialog: false,
      status: false,
      pin: 0,
      otp: false,
      name: [],

      ielts: true,
      toefl: false,
      gre: false,
      sat: false,
      gmat: false,

      countries: [],
      selectedCountry: null,

      courses: ['IELTS', 'TOEFL', 'GRE', 'SAT', 'GMAT'],
      selectedCourse: null,

      form: {
        name: null,
        email: null,
        mobileNumber: null
      },
      form1: {
        otp: null
      },
      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
        },
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },
    };
    
  },
  
   mounted() {
   },

 methods: {
   blg(item) {
     sessionStorage.setItem("blogTitle", item.title);
     sessionStorage.setItem("blogDescription", item.description);
     sessionStorage.setItem("blogSrc", item.src);
     this.$router.push("/blogDetail/" + item.id );
   },

   getOtp() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.pin = Math.floor(1000 + Math.random() * 9000);
        this.axios
          .post(
            config.API + 'enquiry/otp',
            {
              name: this.form.name,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              otp: this.pin
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.otp = true;
            this.btnSave = false;
          })
          .catch(() => {
            this.$toaster.error("Mobile number already exists!!");
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    onSubmit() {
      if (this.$refs.form1.validate()) {
        if(this.pin == this.form1.otp) {
          this.btnSave1 = true;
        this.axios
          .post(
            config.API + `enquiry/author`,
            {
              name: this.form.name,
              email: this.form.email,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              country: this.selectedCountry,
              course: this.selectedCourse,
              page: 'Test Preparation',
              date: moment().format('MMMM Do YYYY')
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log(res);
            this.name = this.form.name.split(' ');
            let firstName = this.name[0];
            let lastName = null;

            if(this.name.length > 2) {
              lastName = this.name[1] + this.name[2]
            }
            else {
              lastName = this.name[1]
            }
            this.axios
          .post(
            `http://api.worldwin.org/api/Leads1`,
            {
              firstName: firstName,
              lastName: lastName,
              mobileNumber: JSON.parse(this.form.subject),
              cmsId: JSON.parse(res.data.result.id),
              email: this.form.email,
              guardianName: null,
              guardianNo: 0,
              guardianEmail: null,
              relation: null,
              address: null,
              nature: null,
              source: null,
              document: false,
              documentType: null,
              notes: null,
              levelId: 0,
              leadDetails: null,
              leadTrainings: null
            },
            {
              headers: {
                Authorization: "bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.dialog = true;
            this.btnSave1 = false;
          })
          .catch(() => {
            this.$toaster.error(`Mobile no is already registered`);
            this.btnSave = false;
          });
          })
          .catch(() => {
            this.$toaster.error("Mobile no is already registered");
            this.btnSave1 = false;
          });
        }
        else {
          this.$toaster.error("Please put a valied OTP");
        }
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    cancel() {
        this.$refs.form1.reset();
        this.otp = false;
        this.dialog = false;
    },
 }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');
</style>

<style scoped>
.banner {
  background-image: url('https://cdnimg.webstaurantstore.com/uploads/seo_category/2018/10/commercial-refrigeration_1.jpg');
  background-size: cover;
  height:200px;
}
.tst {
    background-image: linear-gradient(to bottom,rgba(243, 177, 55, 0.73), rgba(58, 18, 18, 0.73)), url('https://www.Worldwininternational.com/images/img19.png');
    background-size: cover;
    color: white !important;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}

.partner {
    margin-top: 15px;
    text-align: center;
    font-size: 23px;
    background-image: linear-gradient(to right, #f19a28 , #f12525);
    border-radius: 0px !important;
    color: whitesmoke !important;
}


.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offsets {
  top: -50px;
  position: relative;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.v-sheet--offsetf {
  top: -100px;
  position: relative;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
div.scroll { 
                margin:4px, 4px; 
                padding:4px; 
                width: auto; 
                height: 254px; 
                overflow-x: hidden; 
                overflow-x: auto; 
                text-align:justify; 
            }
.tourtheme {
  height: 180px;
  margin: 5px;
  background-size: cover;
}
.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.top-left {
  font-family: 'Roboto Mono', monospace;
  font-size:40px ;
  padding-top: 200px;
  color: white;
  text-align: center;
}
.salont {
  font-family: 'Patua One', cursive;
}
.link:hover {
  cursor: pointer;
  text-decoration: underline;
}
.hvr:hover {
  cursor: pointer;
  border-radius: 5px !important;
  border : 1px solid;
  border-color: black !important;
  transition-duration: 0.7s;
  text-decoration: none !important;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.recent {
  font-family: 'Nanum Gothic', sans-serif;
}
.srch {
  position: absolute;
  z-index: 10;
  left: 16%;
  top: 0%;
}
.item {
    border:1px solid !important;
}
</style>
